(function () {
  class SlSceneShowcase extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.sceneSlider = this.querySelector('[data-sl-scene-slider]');
      this.contentSlides = Array.from(this.querySelectorAll('[data-sl-scene-content-slide]'));
      this.productSlides = Array.from(this.querySelectorAll('[data-sl-scene-product-slide]'));
      this.prevButton = this.querySelector('[data-sl-scene-prev]');
      this.nextButton = this.querySelector('[data-sl-scene-next]');

      if (!this.sceneSlider || !this.contentSlides.length || typeof window.Swiper === 'undefined') return;

      this.sceneSwiper = new window.Swiper(this.sceneSlider, {
        slidesPerView: 1,
        speed: 700,
        effect: 'fade',
        allowTouchMove: true,
        watchOverflow: false,
        autoHeight: false,
      });

      this.sceneSwiper.on('slideChange', this.handleSceneChange);

      this.prevButton?.addEventListener('click', this.handlePrevClick);
      this.nextButton?.addEventListener('click', this.handleNextClick);

      this.updateContent(this.sceneSwiper.activeIndex || 0);
      this.updateNavState();
    }

    handlePrevClick = () => {
      this.sceneSwiper?.slidePrev();
    };

    handleNextClick = () => {
      this.sceneSwiper?.slideNext();
    };

    handleSceneChange = () => {
      if (!this.sceneSwiper) return;
      this.updateContent(this.sceneSwiper.activeIndex);
      this.updateNavState();
    };

    updateContent(activeIndex) {
      this.contentSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
      });

      this.productSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
      });
    }

    updateNavState() {
      if (!this.sceneSwiper) return;

      this.prevButton?.classList.toggle('swiper-button-disabled', this.sceneSwiper.isBeginning);
      this.nextButton?.classList.toggle('swiper-button-disabled', this.sceneSwiper.isEnd);
    }

    disconnectedCallback() {
      this.sceneSwiper?.off?.('slideChange', this.handleSceneChange);
      this.prevButton?.removeEventListener('click', this.handlePrevClick);
      this.nextButton?.removeEventListener('click', this.handleNextClick);
      this.sceneSwiper?.destroy?.(true, true);
    }
  }

  if (!customElements.get('sl-scene-showcase')) {
    customElements.define('sl-scene-showcase', SlSceneShowcase);
  }
})();
